import { render } from "./tracker.vue?vue&type=template&id=2faa63a2"
import script from "./tracker.vue?vue&type=script&lang=js"
export * from "./tracker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/birchplace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__